import React, { useState, useCallback, useEffect } from 'react';
import { Modal, Button } from 'reactstrap';
import { FormControl, MenuItem, Select } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { api } from 'services/api';
import TabDados from './TabDados';
import TabAnexos from './TabAnexos';
import TabNegociacao from './TabNegociacao';
import TabContato from './TabContato';
import '../styles/style-duelist-table.scss';

const useStyles = makeStyles(() => ({
    formControl: {
        margin: 4,
        minWidth: '100px',
        maxWidth: '180px',
        maxHeight: '32px',
        width: '100%',
        padding: '0 4px',
        backgroundColor: '#fff',
        borderRadius: '4px',
        border: '1px solid #d2d6dc',
        '& .MuiSelect-root': { padding: '4px 8px', fontSize: '0.8rem' },
    },
}));

const ProcessModal = ({
    order,
    onClose,
    reload,
    endpoint,
    ordersStatus,
    users,
    showToast,
}) => {
    const classes = useStyles();
    const [tab, setTab] = useState(1);
    const [statusOpen, setStatusOpen] = useState(false);
    const [selectOpen, setSelectOpen] = useState(false);
    const [localOrder, setLocalOrder] = useState(order);

    // Busca dados completos do processo (phones, comments) na montagem do modal,
    // pois o order da prop vem de ProcessListSerializer que não inclui esses campos
    useEffect(() => {
        api.get(`/process/${order.id}/`).then((response) => {
            if (response.data && response.data.id) {
                setLocalOrder(response.data);
            }
        }).catch((error) => {
            console.error('Falha ao carregar dados do processo:', error);
        });
    }, [order.id]);

    // Atualiza o order local buscando dados completos (phones, comments) via GET /process/{id}/
    // O reload() da lista continua sendo chamado para manter a tabela sincronizada
    const reloadOrder = useCallback(async (endpoint, options) => {
        await reload(endpoint, options);
        try {
            const response = await api.get(`/process/${order.id}/`);
            if (response.data && response.data.id) {
                setLocalOrder(response.data);
            }
        } catch (error) {
            console.error('Falha ao recarregar dados do processo:', error);
        }
    }, [reload, order.id]);

    const orderStatusSelected = localOrder.status?.length > 0 ? localOrder.status[0].status_data.id : "";

    const userIsAdmin = () => {
        const userId = localStorage.getItem('AUTHOR_ID');
        const userData = users.find((u) => u.id === parseInt(userId));
        if (!userData) return false;
        return userData.is_superuser;
    };

    const handleStatusState = () => {
        const next = !statusOpen;
        setStatusOpen(next);
        if (next) setSelectOpen(true);
    };

    const saveStatusOrder = (value) => {
        if (value === "") return showToast('warning', 'Selecione um status!');
        if (orderStatusSelected === value) {
            handleStatusState();
            return;
        }
        const action = localOrder.status?.length > 0 ? "update" : "create";
        const user = localStorage.getItem('AUTHOR_ID');
        const data = { status_id: value, user_id: user, process_id: localOrder.id };

        if (action === "create") {
            api.post("/process/status/", data).then(async () => {
                handleStatusState();
                showToast('success', 'Atribuído com sucesso ao status');
                await reloadOrder(endpoint, { loader: false });
            }).catch((error) => {
                showToast('error', 'Erro ao atribuir o status a essa ordem');
                console.error(error);
            });
        } else {
            api.patch(`/process/status/${localOrder.status[0].id}/`, data).then(async () => {
                handleStatusState();
                showToast('success', 'Atribuído com sucesso ao status');
                await reloadOrder(endpoint, { loader: false });
            }).catch((error) => {
                showToast('error', 'Erro ao atribuir o status a essa ordem');
                console.error(error);
            });
        }
    };

    const handleSelect = (e) => saveStatusOrder(e.target.value);

    const handleClose = () => {
        if (statusOpen) handleStatusState();
        onClose();
    };

    const tabConfig = [
        { id: 1, label: 'Dados do Processo' },
        { id: 4, label: 'Dados de Contato' },
        { id: 3, label: 'Negociação' },
        { id: 2, label: 'Anexos' },
    ];

    return (
        <Modal
            className="modal-dialog-centered"
            size="xl"
            isOpen={true}
            toggle={handleClose}
        >
            <div className="modal-header shadow-sm" style={{ backgroundColor: "#fff", borderBottom: "1px solid #e9ecef" }}>
                <div className="container-tabs-modal d-flex align-items-center" style={{ flex: 1, gap: "20px" }}>
                    {tabConfig.map(({ id, label }) => (
                        <div
                            key={id}
                            className={`tab-modal ${tab === id ? "tab-modal-selected" : ""}`}
                            onClick={() => setTab(id)}
                            style={{ cursor: "pointer", paddingBottom: "10px", borderBottom: tab === id ? "2px solid #C2641A" : "none" }}
                        >
                            <span className="header-title-duelist-modal font-weight-600" style={{ color: tab === id ? "#C2641A" : "#8898aa" }}>
                                {label}
                            </span>
                        </div>
                    ))}
                </div>
                <div className="buttons-header-duelist-modal ml-auto">
                    {statusOpen ? (
                        <FormControl required className={classes.formControl}>
                            <Select
                                labelId="process-status-label"
                                id="process-status-select"
                                open={selectOpen}
                                onOpen={() => setSelectOpen(true)}
                                onClose={() => {
                                    setSelectOpen(false);
                                    handleStatusState();
                                }}
                                value={orderStatusSelected}
                                onChange={handleSelect}
                                style={{ color: '#fff', minWidth: 140 }}
                            >
                                <MenuItem value=""><em>Nenhum</em></MenuItem>
                                {ordersStatus.map((statusItem, index) => (
                                    <MenuItem key={`status-item-${index}`} value={statusItem.id}>
                                        <em>{statusItem.name}</em>
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    ) : (
                        <Button
                            color="primary"
                            size="sm"
                            onClick={handleStatusState}
                            outline
                        >
                            {localOrder.status?.length > 0 ? localOrder.status[0].status_data.name : "Adicionar Status"}
                        </Button>
                    )}
                    <button
                        aria-label="Close"
                        className="close"
                        data-dismiss="modal"
                        type="button"
                        onClick={handleClose}
                        style={{ color: '#fff', marginLeft: 8 }}
                    >
                        <span aria-hidden={true}>×</span>
                    </button>
                </div>
            </div>
            <div className="modal-body p-0">
                <div className="container-list-duelist-modal">
                    {tab === 1 && <TabDados order={localOrder} />}
                    {tab === 2 && <TabAnexos order={localOrder} reload={reloadOrder} endpoint={endpoint} showToast={showToast} />}
                    {tab === 3 && <TabNegociacao order={localOrder} reload={reloadOrder} endpoint={endpoint} userIsAdmin={userIsAdmin} showToast={showToast} />}
                    {tab === 4 && <TabContato order={localOrder} reload={reloadOrder} endpoint={endpoint} showToast={showToast} />}
                </div>
            </div>
        </Modal>
    );
};

export default ProcessModal;
